import React from "react";

import { useContextMenu } from "@amphore-dev/amphore-lib";

import { TProject, TTask } from "@/types";

import { ContextMenusContext, TViewCtxMenuData } from "./context";

/**
 * One controller per menu (lib's `useContextMenu` model: any number of
 * triggers, one shared `<ContextMenu>` render) — shared here via context
 * since triggers (TaskListItem, TasksList's header button)
 * and the menu itself (ViewsCtxMenu/ProjectsCtxMenu/TasksListCtxMenu)
 * live in different, sometimes distant, parts of the tree.
 */
export const ContextMenusProvider: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => {
	const views = useContextMenu<TViewCtxMenuData>();
	const projects = useContextMenu<TProject>();
	const tasksList = useContextMenu<TTask>();

	return (
		<ContextMenusContext.Provider value={{ views, projects, tasksList }}>
			{children}
		</ContextMenusContext.Provider>
	);
};
